:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.section-heading {
  font-weight: bold;
  margin: 0;
}

@media screen and (max-width: 979px) {
  .section-heading {
    font-size: 1rem;
    line-height: 1.5625rem;
  }
}

@media screen and (min-width: 980px) {
  .section-heading {
    font-size: 1.75rem;
    line-height: 1.875rem;
  }
}

.section-heading--color-default {
  color: #3dcd58;
}

.section-heading--color-inherit {
  color: inherit;
}

.section-heading--color-secondary-fuchsia {
  color: #b10043;
}

.section-heading--in-products-filters {
  font-size: 1.875rem;
}

@media screen and (max-width: 979px) {
  .section-heading--in-products-filters {
    font-size: 1.5625rem;
    margin-bottom: 1.25rem;
  }
}